module.exports = __webpack_public_path__ + "media/brands/intrall-409ceea1.png";